import _Promise from 'babel-runtime/core-js/promise';
import { login, logout } from '@/api/login';

import { adminUsersRead } from '@/api/personCenter/personCenter';

import { removeAuth } from '@/utils/auth';

import Lockr from 'lockr';

var user = {
  state: {
    userInfo: null // 用户信息
    // 权限信息
    //allAuth: null, //总权限信息 默认空 调整动态路由
  },

  mutations: {
    SET_USERINFO: function SET_USERINFO(state, userInfo) {
      state.userInfo = userInfo;
    },
    SET_PEIMISSIONARR: function SET_PEIMISSIONARR(state, permissionArr) {
      state.permissionArr = permissionArr;
    }
  },

  actions: {
    // 登录接口调用
    Login: function Login(_ref, userInfo) {
      var commit = _ref.commit;

      var username = userInfo.username.trim();
      return new _Promise(function (resolve, reject) {
        login(username, userInfo.password).then(function (data) {
          //登录接口返回信息记录在vuex和lockr中
          if (data.values.flag) {
            var userinfo = data.values.LoginInfo;
            Lockr.set('loginState', data.values.flag);
            Lockr.set('loginUserInfo', userinfo);
            // 在登录的时候赋值权限，把object转化为Arry
            var permissionArr = [];
            for (var key in data.values.permissionMap) {
              permissionArr.push(key);
            }
            Lockr.set('permissionArr', permissionArr);
            //登录成功
            commit('SET_USERINFO', userinfo);
            commit('SET_PEIMISSIONARR', permissionArr);
            resolve(data);
          } else {
            reject(data.values.message);
          }
        }).catch(function (error) {
          reject(error.values.message);
        });
      });
    },


    // 获取用户信息  并把信息存在vuex  userInfo中
    // GetUserInfo({ commit, state }) {
    //   return new Promise((resolve, reject) => {
    //     adminUsersRead().then(response => {
    //       commit('SET_USERINFO', response.data)
    //       resolve(response)
    //     }).catch(error => {
    //       reject(error)
    //     })
    //   })
    // },

    // 退出登录
    LogOut: function LogOut(_ref2) {
      var commit = _ref2.commit;

      return new _Promise(function (resolve, reject) {
        logout().then(function () {
          /** flush 清空localStorage .rm('authKey') 按照key清除 */
          removeAuth();
          commit('SET_USERINFO', null);
          resolve();
        }).catch(function (error) {
          reject(error);
        });
      });
    }
  }
};

export default user;